// export.ts — CSV export of the key-dates ledger (all local; nothing leaves the device).
// Lets the user pull their renewal/expiry/notice deadlines into a calendar/spreadsheet.

import type { KeyDate } from "./store";
import { LABEL_TEXT, KIND_LABELS, fmtDate } from "./store";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** Full CSV: Date, What, Document, Kind, Context. */
export function keyDatesCsv(dates: KeyDate[]): string {
  return csv(
    ["Date", "Date (pretty)", "What", "Document", "Kind", "Context"],
    dates.map((k) => [
      k.date,
      fmtDate(k.date),
      LABEL_TEXT[k.label],
      k.doc_title,
      KIND_LABELS[k.kind],
      k.context,
    ]),
  );
}

export function buildExport(dates: KeyDate[]): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  return { csv: keyDatesCsv(dates), filename: `lockbox-key-dates-${stamp}.csv` };
}
